import React from "react";

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

export function PageHeader({
  title,
  subtitle,
  icon,
  actions,
  className = "",
}: PageHeaderProps) {
  return (
    <section
      className={`mb-4 rounded-2xl border border-slate-200/80 bg-white p-3 shadow-subtle md:mb-5 md:rounded-3xl md:p-5 ${className}`}
    >
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div className="flex min-w-0 items-center gap-3 md:gap-4">
          {icon ? (
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary-50 text-xl text-primary-700 shadow-sm md:h-12 md:w-12 md:rounded-2xl md:text-2xl">
              {icon}
            </div>
          ) : null}
          <div className="min-w-0">
            <h1 className="truncate text-xl font-bold tracking-tight text-slate-950 md:text-3xl">
              {title}
            </h1>
            {subtitle ? (
              <p className="mt-0.5 text-xs font-medium leading-5 text-slate-500 md:mt-1 md:text-sm md:leading-relaxed">
                {subtitle}
              </p>
            ) : null}
          </div>
        </div>
        {actions ? (
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center">{actions}</div>
        ) : null}
      </div>
    </section>
  );
}
